import axios from "axios";

import type {FetchNUXSettingsResponse} from "@songfinch/types";

export async function fetchNUXSettings(): Promise<FetchNUXSettingsResponse> {
    const res = await axios.get<FetchNUXSettingsResponse>(`/new_user_experience_settings`);
    return res.data;
}


export async function updateNUXSettings(placementId: string): Promise<FetchNUXSettingsResponse> {
    const res = await axios.put<FetchNUXSettingsResponse>(`/new_user_experience_settings/${placementId}`);
    return res.data;
}